import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const navSections = [
  {
    id: 'company',
    label: 'Company',
    links: [
      { label: 'About Sapiencia', to: '/about' },
      { label: 'Partners', to: '/partners' },
    ],
  },
];

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  const closeMenu = () => {
    setIsMenuOpen(false);
    setOpenDropdown(null);
  };

  const isCurrentPage = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }

    return location.pathname.startsWith(path);
  };

  const isCurrentGroup = (links) =>
    links.some((link) => isCurrentPage(link.to));

  const handleDropdownToggle = (id) => {
    setOpenDropdown((prev) => (prev === id ? null : id));
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        setOpenDropdown(null);
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('keydown', handleEsc);

    return () => document.removeEventListener('keydown', handleEsc);
  }, []);

  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  return (
    <>
      {/* ==== Top Navigation Bar ==== */}
      <nav
        className="navbar fixed-nav"
        role="navigation"
        aria-label="Main Navigation"
        onMouseLeave={() => setOpenDropdown(null)}
      >
        <div className="navbar-left">
          <Link
            to="/"
            className="navbar-logo"
            onClick={closeMenu}
            aria-label="Sapiencia.AI Home"
          >
            <img
              src="/no_backg_logo.jpeg"
              alt="Sapiencia.AI logo"
              className="navbar-logo-img"
              width="48"
              height="48"
            />

            <div className="company_name">Sapiencia.AI</div>
          </Link>
        </div>

        {/* Desktop Navigation */}
        <div className="navbar-links-desktop">
          <ul className="navbar-links">

 <li className="navbar-item">
  <Link
    to="/"
    onClick={closeMenu}
    className={isCurrentPage('/') ? 'current-page' : ''}
  >
    Home
  </Link>
</li>
            <li className="navbar-item">
              <Link
                to="/solutions"
                onClick={closeMenu}
                className={isCurrentPage('/solutions') ? 'current-page' : ''}
              >
                Solutions
              </Link>
            </li>

            <li className="navbar-item">
              <Link
                to="/resources"
                onClick={closeMenu}
                className={isCurrentPage('/resources') ? 'current-page' : ''}
              >
                Resources
              </Link>
            </li>

            {/* CHANGED ONLY THIS PART */}
            <li className="navbar-item">
              <Link
                to="/about"
                onClick={closeMenu}
                className={isCurrentPage('/about') ? 'current-page' : ''}
              >
                Company
              </Link>
            </li>

            <li className="navbar-item">
              <Link
                to="/contact"
                onClick={closeMenu}
                className={isCurrentPage('/contact') ? 'current-page' : ''}
              >
                Contact
              </Link>
            </li>

          </ul>
        </div>
        <button
          className="navbar-toggle"
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          ☰
        </button>
      </nav>

      {/* ==== Mobile Dropdown Menu ==== */}
<div className={`navbar-dropdown ${isMenuOpen ? 'active' : ''}`}>
  <ul className="navbar-links-mobile">
    <li className="mobile-section">
      <Link to="/" onClick={closeMenu} className={isCurrentPage('/') ? 'current-page' : ''}>
        Home
      </Link>
    </li>

    <li className="mobile-section">
      <Link to="/solutions" onClick={closeMenu} className={isCurrentPage('/solutions') ? 'current-page' : ''}>
        Solutions
      </Link>
    </li>

    <li className="mobile-section">
      <Link to="/resources" onClick={closeMenu} className={isCurrentPage('/resources') ? 'current-page' : ''}>
        Resources
      </Link>
    </li>

    <li className="mobile-section">
      <Link to="/about" onClick={closeMenu} className={isCurrentPage('/about') ? 'current-page' : ''}>
        Company
      </Link>
    </li>

    <li className="mobile-section">
      <Link to="/contact" onClick={closeMenu} className={isCurrentPage('/contact') ? 'current-page' : ''}>
        Contact
      </Link>
    </li>
  </ul>

  <div className="navbar-cta-mobile">
    <Link to="/contact" className="cta-button-demo" onClick={closeMenu}>
      Request a Demo
    </Link>
  </div>
</div>

</>
  );
};

export default Navbar;